import Icon from "../Icon";

export { LockIndicator };

type Props = {
  /**
   * User that owns lock
   */
  lockedBy: string;
  /**
   * Current user.
   */
  currentUser: string;
};

/*

Style .icon>path with the following CSS to render an outline 
{
    stroke-width: 2rem;
    stroke: black;
    outline: 1px solid black;
    stroke-linejoin: round;
}
*/

const LockIndicator = ({ lockedBy, currentUser }: Props) => {
  return (
    <Icon
      icon={"lock"}
      altText={`Locked by ${lockedBy}`}
      // TODO: unique display when current user owns lock
      color={
        lockedBy === currentUser
          ? "var(--lock-current-user)"
          : "var(--lock-other-user)"
      }
    />
  );
};
